<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row" style="border-bottom: 1px solid #F2F5F7">
                <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
                    <img src="../../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-7 col-sm-7 col-7 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Tahapan Produksi</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2"></div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="animasi-card  bg-transparent d-flex mar-top-16 mar-bottom-16">
                        <div class="font-16 status-login color-206CF"><span class="font-weight-bold color-206CF">Langkah 2/2</span></div>
                    </div>
                    <div class="text-outlets mar-bottom-20">
                        <div class="font-16 color-0000">Silahkan pilih apa saja tahapan produksi yang akan dikerjakan</div>
                    </div>
                    <div class="custom-control custom-checkbox remove-padding" v-for="data in dataProductionWorkshop.dataTahapan" :key="data.idtahapan">
						<!--<input type="checkbox" class="custom-control-input" v-bind:id="data.idtahapan" :value="data.idtahapan" v-if="data.idtahapan === 8000" checked disabled v-model="dataProductionWorkshop.checklisttahapan">-->
                        <input type="checkbox" class="custom-control-input" :value="data.idtahapan" v-bind:id="data.idtahapan" v-model="dataProductionWorkshop.checklisttahapan">
                        <label class="custom-control-label font-colorcheck" v-bind:for="data.idtahapan" >{{ data.text }}</label>
                    </div>
                    <div class="text-outlets">
                        <h6><span style="color: #206CFF;">*</span>pengemasaan wajib dilakukan dalam produksi</h6>
                    </div>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long"  id="BtnCreateTahapanlist" @click="Post">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="dataProductionWorkshop.isClicked === true"></span>
                        <span id="textBtnCreateTahapanlist">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "ProductionWorkshop",
        data(){
            return{
	            requestHeaders: {
		            headers: {
			            'Authorization': 'Bearer ' + localStorage.getItem('token'),
		            }
	            },
            }
        },
        props:["dataProductionWorkshop","dataDataWorkshop"],
        mounted(){
            this.getTahapan();
        },
        methods:{
            back(){
                this.$emit('showdataworkshopFromProd', false)
            },
            next(){
              this.$emit('PostWorkshop')
            },
            showdetailworkshopcreate(idworkshop){
                this.$emit('showdetailworkshop',idworkshop)
            },


            async getTahapan(){
                this.dataProductionWorkshop.dataTahapan=[];
                this.dataProductionWorkshop.checklisttahapan=[8000]
                try{
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta', this.requestHeaders)
                    if(response.status===200){
                        var rawtahapan= response.data.data
                        for(var i = 0; i < rawtahapan.length; i++){
                            this.dataProductionWorkshop.dataTahapan.push({idtahapan: rawtahapan[i].idtahapan, text: rawtahapan[i].nama})
                        }
                    }
                }
                catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async Post(){
	            if (!this.dataProductionWorkshop.checklisttahapan.includes(8000)) {
		            this.$toast.error("Tahpan Pengemasan wajib dicentang")
		            return
	            }

                this.dataProductionWorkshop.isClicked= true
                $('#textBtnCreateTahapanlist').hide();
                $('#BtnCreateTahapanlist').prop('disabled', true);
                try {
                    const dataworkshop = new FormData;
                    dataworkshop.append('idowner',localStorage.getItem('idowner'));
                    dataworkshop.append('nama_workshop', this.dataDataWorkshop.nama);
                    dataworkshop.append('telp_workshop', this.dataDataWorkshop.telp_code + this.dataDataWorkshop.telp);
                    dataworkshop.append('alamat_workshop', this.dataDataWorkshop.Alamat);
                    dataworkshop.append('kota_workshop',this.dataDataWorkshop.selectedkota);
                    for(var i = 0; i < this.dataProductionWorkshop.checklisttahapan.length; i ++) {
                        dataworkshop.append('tahapan[]', this.dataProductionWorkshop.checklisttahapan[i])
                    }
                    const res = await this.$axios.post(this.$baseurl + '/masterData/outlet/create_workshop', dataworkshop, this.requestHeaders)
                    if (res.data.status === true) {
                        this.showdetailworkshopcreate(res.data.data.idworkshop);
                        this.dataDataWorkshop.nama='';
                        this.dataDataWorkshop.telp='';
                        this.dataDataWorkshop.Alamat='';
                        this.dataDataWorkshop.selectedkota='1';
                        this.dataProductionWorkshop.checklisttahapan=[8000];
                        this.dataProductionWorkshop.isClicked = false;
                        $('#textBtnCreateTahapanlist').show();
                        $('#BtnCreateTahapanlist').prop('disabled', false);
                        this.$toast.success(res.data.msg)
                    } else {
                    	this.$toast.error(res.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.dataProductionWorkshop.isClicked = false;
	                $('#textBtnCreateTahapanlist').show();
	                $('#BtnCreateTahapanlist').prop('disabled', false);
                }
            },
        }
    }
</script>

<style scoped>

</style>